module.exports = "/_next/static/images/todo-4c679a213ffdbb85fb1d8b08ec642ec8.svg";